import { notNullLike } from "./notNullLike";

export function formatYesNoMaybe(value?: boolean | null | undefined) {
	if (notNullLike(value)) {
		return value ? "Yes" : "No";
	}
	return "-";
}
